import { breakpoints } from './breakpoints'
import { colors } from './colors'
import {zIndex} from './zIndex'

const theme = {
  colors,
  breakpoints,
  fontSizes: [12, 14, 16, 20, 24, 45],
  zIndex,
}

export default theme
